import styled from "styled-components";
import { mq } from "./util/media";

import TwitterIcon from '../images/twitter.svg';
import TelegramIcon from '../images/telegram.svg';
import MediumIcon from '../images/medium.svg';
import DocsIcon from '../images/docs.svg';
import WebappIcon from '../images/webapp.svg';

const FooterWrapper = styled.footer`
  max-width: 1200px;
  margin-top: 8rem;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  margin: 0 auto;
`

const FooterInner = styled.div`
  display: flex;
  justify-content: space-between;

  ${mq.lt.md} {
    flex-direction: column;
    gap: 2rem;
  }



  ${mq.lt.sm} {
    flex-direction: column-reverse;
    gap: 1.8rem;
  }
`

const FooterLinks = styled.ul`
  & a {
    color: #CEBFBF;
    text-decoration: none;
  }

  padding: 0;
  margin:0;

  font-size: 0.75rem;
  font-weight: 900;
  display: flex;
  justify-content: space-between;
  gap: 2rem;
  list-style: none;
  text-transform: uppercase;

  ${mq.lt.md} {
    gap: 2rem;
    justify-content: center;
  }

  ${mq.lt.sm} {
    flex-wrap: wrap;
    gap: 1rem;
    justify-content: center;
    row-gap: 1.8rem;

    & li:nth-child(1) {
      order: 1;
    }

    & li:nth-child(2) {
      order: 2;
    }

    & li:nth-child(3) {
      order: 4;
    }

    & li:nth-child(4) {
      order: 3;
    }

    & li:nth-child(5) {
      order: 5;
    }
  }
`

const FooterSocial = styled.ul`
  padding: 0;
  margin:0;

  font-size: 0.75rem;
  font-weight: 900;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2.3rem;
  list-style: none;
  text-transform: uppercase;

  li a {
    display: flex;
    align-items: center;
    gap: 0.3rem;
    color: #CEBFBF;
    text-decoration: none;
    font-weight: 900;
  }

  ${mq.lt.md} {
    justify-content: center;
  }
`

const Copyright = styled.span`
  font-size: 0.6rem;
  font-weight: 900;
  padding-top: 6rem;

  ${mq.lt.md} {
    padding-top: 2rem;
    text-align: center;
  }

  ${mq.lt.sm} {
    padding-top: 1.8rem;
    text-align: center;
  }

  a {
    color: #CEBFBF;
    text-decoration: none;
  }
`

function Footer () {
  return (
    <FooterWrapper>

      <FooterInner>
        <FooterLinks>
          <li>
            <a href="https://t.me/neartreasury" target="_blank" rel="noreferrer">Contact</a>
          </li>
          <li>
            <a href="https://neartreasury.io/docs/NearTreasuryLitepaper.pdf" target="_blank" rel="noreferrer">Litepaper</a>
          </li>
          <li>
            <a href="https://www.ref.finance/" target="_blank" rel="noreferrer">Official Ref Finance</a>
          </li>
          <li>
            <a href="mailto:team@neartreasury.io" target="_blank" rel="noreferrer">We're Hiring</a>
          </li>
          <li>
            <a href="/webapp" target="_blank" rel="noreferrer">Audit</a>
          </li>
        </FooterLinks>

        <FooterSocial>
          <li>
            <a href="https://twitter.com/NEARTreasury" target="_blank" rel="noreferrer"><img src={TwitterIcon} alt="" /></a>
          </li>
          <li>
            <a href="https://t.me/neartreasury" target="_blank" rel="noreferrer"><img src={TelegramIcon} alt="" /></a>
          </li>
          <li>
          <a href="https://medium.com/@neartreasury" target="_blank" rel="noreferrer"><img src={MediumIcon} alt="" /></a>
          </li>
          <li>
            <a href="https://near-treasury.gitbook.io/near-treasury-tm/" target="_blank" rel="noreferrer"><img src={DocsIcon} alt="" /> Docs</a>
          </li>
          <li>
            <a href="/webapp" target="_blank" rel="noreferrer"><img src={WebappIcon} alt="" /> Webapp</a>
          </li>
        </FooterSocial>

      </FooterInner>
      
      <Copyright>© Copyright 2022 - <a href="https://medium.com/@neartreasury/terms-of-service-56987615347d" target="_blank" rel="noreferrer">Legal</a> - <a href="https://medium.com/@neartreasury/near-treasury-disclaimers-f2f738aeadd9" target="_blank" rel="noreferrer">Disclaimer</a></Copyright>

    </FooterWrapper>
  )
}

export default Footer;